import { Button } from 'components/common'
import SearchBar from 'components/common/dataTable/searchBar'
import { PlusIcon } from 'components/icons'
import { FtpProfilesTable } from 'components/ftpProfiles'
import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { PAGE_ADD_FTP_PROFILE } from 'utils/constants'

const FtpProfiles = () => {
  const navigate = useNavigate()

  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | FTP Profiles</title>
      </Helmet>

      {/* Create FTP Profile Button */}
      {isEditor && (
        <Button
          buttonText="Create New FTP Profile"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_ADD_FTP_PROFILE.path)}
        />
      )}

      <div
        className={`${
          isEditor ? 'mt-4' : ''
        } mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap`}
      >
        <h3 className="title">Current FTP Profiles</h3>
        <SearchBar placeholder="Search by Profile Name" />
      </div>

      {/* FTP Profile List */}
      <FtpProfilesTable isEditor={isEditor} />
    </>
  )
}

export default FtpProfiles
